export class ErrorLogQueryInfo{
    startTime: number
	endTime: number
	message: string
	level: string
	contextMapKey: string
	searchText: string
}